import React, { useState } from "react";
import "./addHelpTeam.css";
import { addHelpTeam } from "../../api/helpTeam";
import { Cookies } from "react-cookie";

const AddHelpTeam = (props) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    image: null,
    name: "",
    strength: "",
    phone: "",
    whatsapp: "",
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    e.target.setCustomValidity("");
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    e.target.setCustomValidity("");
    setFormData((prev) => ({
      ...prev,
      image: e.target.files[0],
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const formBack = new FormData();
    formBack.append("image", formData.image);
    formBack.append("name", formData.name);
    formBack.append("age", 0);
    formBack.append("profession", "N/A");
    formBack.append("experience", 5);
    formBack.append("strength", formData.strength);
    formBack.append("phone", formData.phone);
    formBack.append("whatsapp", formData.whatsapp);
    formBack.append("email", formData.email);
    formBack.append("password", formData.password);
    addHelpTeam(formBack).then((result) => {
      setFormData({
        image: null,
        name: "",
        strength: "",
        phone: "",
        whatsapp: "",
        email: "",
        password: "",
      });
      setLoading(false);
    });
  };

  return (
    <div className="add-brokers-guideline">
      <form onSubmit={handleSubmit}>
        {formData.image && (
          <img
            src={URL.createObjectURL(formData.image)}
            alt="Uploaded"
            style={{ maxWidth: "100%", marginTop: "10px" }}
          />
        )}
        <div className="form-group">
          <label htmlFor="image">Image</label>
          <input
            type="file"
            id="image"
            name="image"
            onChange={handleFileChange}
            accept="image/*"
            required
            onInvalid={(e) => e.target.setCustomValidity("Image is required")}
          />
        </div>

        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter name"
            required
            onInvalid={(e) => e.target.setCustomValidity("Name is required")}
          />
        </div>
        <div className="form-group">
          <label htmlFor="strength">Strength</label>
          <input
            type="text"
            id="strength"
            name="strength"
            value={formData.strength}
            onChange={handleChange}
            placeholder="Enter strength"
            required
            onInvalid={(e) =>
              e.target.setCustomValidity("Strength is required")
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="phone">Phone</label>
          <input
            type="text"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Enter phone"
            maxLength="11"
            pattern="^01[0-2,5]\d{1,8}$"
            required
            onInvalid={(e) => e.target.setCustomValidity("Phone is required")}
          />
        </div>
        <div className="form-group">
          <label htmlFor="whatsapp">whatsapp</label>
          <input
            type="text"
            id="whatsapp"
            name="whatsapp"
            value={formData.whatsapp}
            onChange={handleChange}
            placeholder="Enter whatsapp"
            maxLength="11"
            pattern="^01[0-2,5]\d{1,8}$"
            required
            onInvalid={(e) =>
              e.target.setCustomValidity("whatsapp is required")
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="text"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter email"
            required
            onInvalid={(e) => e.target.setCustomValidity("Email is required")}
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Enter password"
            required
            onInvalid={(e) =>
              e.target.setCustomValidity("Password is required")
            }
          />
        </div>

        {props.isSuper && (
          <>
            {loading ? (
              <div
                style={{
                  width: "100%",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <div className="spinner"></div>
              </div>
            ) : (
              <button type="submit" className="submit-button">
                Add team
              </button>
            )}
          </>
        )}
      </form>
    </div>
  );
};

export default AddHelpTeam;
